<template>
  <div
    :class="{ 'entrepot-page--mobile': !isDesktopLayout }"
    :style="!isDesktopLayout ? mobilePageStyle : null"
  >
    <entrepot-desktop-bridge v-if="isDesktopLayout" />
    <entrepot-mobile v-else />

    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="costDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="costDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("cost") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <cost type="cost" :ref-id="selectedItem" @input="setCost" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="costListDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="costListDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("costs") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>
                      {{ $t("number") }}
                    </th>
                    <th>
                      {{ $t("cost") }}
                    </th>
                    <th>
                      {{ $t("amount") }}
                    </th>
                    <th>
                      {{ $t("actions") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, i) in costItems && costItems.cost
                      ? costItems.cost
                      : []"
                    :key="item.id"
                  >
                    <td>{{ Number(i) + 1 }}</td>
                    <td>{{ item.id }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ $numberFormat(item.amount) }}</td>
                    <td>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            color="pink"
                            x-small
                            icon
                            v-on="on"
                            @click="remoceCostList(item)"
                          >
                            <v-icon small> mdi-trash-can-outline </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("remove") }}</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6"> </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <serial-management-dialog
      v-model="serialDialog"
      :product="(serialItem && serialItem.product) || {}"
      :entrepot="entrepot || {}"
      :total-count="serialItem && serialItem.count"
      :serials="serialDialogList"
      :serial-flow="serialFlow"
      :loading="serialsLoading"
      :has-more="serialHasMore"
      :selected-serials="(serialItem && serialItem.serials) || []"
      :readonly="isTransferReceiptReadonly"
      @confirm="setSerials"
      @search="onSerialSearch"
      @load-more="loadMoreSerials"
    />
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </div>
</template>

<script>
import Task from "../task/task";
import Cost from "../cost&income/cost";
import General from "../../../../Mixins/general";
import Description from "../../components/general/description/Description";
import FormAttachmentDoc from "../../components/general/FormAttachmentDoc";
import SerialManagementDialog from "../../components/general/serials/SerialManagementDialog";
import EntrepotTableRow from "./partial/EntrepotTableRow.vue";
import EntrepotDesktopBridge from "./layouts/desktop/EntrepotDesktopBridge.vue";
import EntrepotMobile from "./layouts/mobile/EntrepotMobile.vue";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
export default {
  name: "EntrepotIndex",
  provide() {
    return { entrepot: this };
  },
  components: {
    EntrepotDesktopBridge,
    EntrepotMobile,
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    FormAttachmentDoc,
    Description,
    Task,
    Cost,
    SerialManagementDialog,
    EntrepotTableRow,
  },
  mixins: [General],
  props: ["input", "formType", "refId"],
  data: () => ({
    selected: [],
    costDialog: false,
    attachments: null,
    costManagament: null,
    costItems: null,
    content: null,
    selectedItem: null,
    serialDialog: false,
    serialItem: null,
    serialsLoading: false, 
    serialPage: 1, 
    serialLastPage: 1, 
    serialSearch: "", 
    serialCancelToken: null, 
    serialRequestId: 0, 
    printDialog: false,
    costListDialog: false,
    deletDialog: false,
    showSelect: false,
    render: false,
    filter: false,
    valid: true,
    detail: null,
    recipientEntrepot: null,
    recipientBranch: null,
    relations: null,
    productStatus: null,
    productStatusItems: null,
    date: null,
    entrepot: null,
    model: null,
    from: 1,
    taskDialog: null,
    id: null,
    status: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 1000,
    isLoading: false,
    snakbar: false,
    type: "receipt",
    taskId: null,
    snakbarText: null,
    loading: true,
    tableOptions: {
      itemsPerPage: 1000,
    },
    tableHeightEntrepot: 380,
    headers: null,
    selectedHeaders: [],
    search: null,
    excelItems: [],
    options: {
      locale: "en-US",
      prefix: "",
      suffix: " ",
      precision: 0,
    },
  }),
  watch: {
    refId(val, oldVal) {
      // this.items = []
      // this.getItems()
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    tableOptions: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.tableOptions.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    relations() {
      var app = this;
      if (app.relations && app.relations.article && !app.id) {
        app.items = [];
        app.items = app.relations.article;
        app.items.map(function (value, key) {
          value.cost = [];
        });
      } else {
        // app.addRow()
      }
    },
    entrepot(val, oldVal) {
      if (!oldVal && this.items.length === 0 && !this.id) {
        this.addRow();
      }
    },
  },
  computed: {
    isDesktopLayout() {
      return this.$vuetify.breakpoint.width >= 800;
    },
    // Mobile bottom nav is dashboard-only; no reserved footer space here.
    mobilePageStyle() {
      const appBar = 52;
      const bottomNav = 0;
      const height = `calc(100dvh - ${appBar}px)`;
      return {
        height,
        maxHeight: height,
        marginBottom: bottomNav ? `-${bottomNav}px` : "0",
        paddingBottom: bottomNav ? `${bottomNav}px` : "0",
        boxSizing: "border-box",
        background: "#fff",
        overflow: "hidden",
      };
    },
    serialFlow() {
      const inputTypes = ["receipt", "tempReceipt"];
      const outputTypes = [
        "remittance",
        "useRemittance",
        "transferRemittance",
        "transferProductStock",
      ];
      if (inputTypes.includes(this.type)) return "in";
      if (outputTypes.includes(this.type)) return "out";
      return "in";
    },
    serialDialogList() {
      if (!this.serialItem) return [];
      if (this.serialFlow === "out") {
        return this.serialItem.serialOptions || [];
      }
      return this.serialItem.serials || [];
    },
    serialHasMore() {
      return this.serialFlow === "out" && this.serialPage < this.serialLastPage;
    },
    isTransferReceiptReadonly() {
      return this.type === "transferReceipt";
    },
    entrepotColumnPersistKey() {
      return "entrepot-table-columns-" + (this.type || "tempReceipt");
    },
    entrepotColumnPlugins() {
      return {
        headers: this.headers,
        visibleHeaders: this.showHeaders,
        locked: ["actions", "row", "product"],
        anchor: "product",
        minWidth: 80,
        persistKey: this.entrepotColumnPersistKey,
      };
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (app.type !== "warehouseHandling") {
          if (app.type === "transferProductStock") {
            if (
              s.value === "counting_one" ||
              s.value === "counting_two" ||
              s.value === "price" ||
              s.value === "expire_date"
            ) {
            } else {
              return app.selectedHeaders.includes(s);
            }
          } else {
            if (
              s.value === "counting_one" ||
              s.value === "counting_two" ||
              s.value === "price" ||
              s.value === "to_product"
            ) {
            } else {
              return app.selectedHeaders.includes(s);
            }
          }
        } else {
          if (s.value !== "to_product") {
            return app.selectedHeaders.includes(s);
          }
        }
      });
    },
    filteredItems() {
      if (!this.search) return this.items;
      const s = this.search.toLowerCase();
      return this.items.filter((item) => {
        const product = item.product;
        if (!product) return false;
        // CASE 1: autocomplete returns object → use product.name
        if (product.name) {
          return product.name.toLowerCase().includes(s);
        }
        return false;
      });
    },
  },
  beforeMount() {
    var storage = JSON.parse(localStorage.getItem("token"));
    this.costManagament = storage.init.goodCostManagement.value;
    this.type = this.$route.name;
    if (this.$route.params.id != null) {
      this.render = false;
      this.id = this.$route.params.id;
      this.show();
    } else {
      this.render = true;
      if (this.entrepot) {
        this.addRow();
      }
    }
  },
  mounted() {
    this.headers = [
      {
        text: "#",
        align: "start",
        sortable: false,
        value: "actions",
        width: 40,
        minWidth: 40,
      },
      {
        text: this.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 40,
        minWidth: 40,
      },
      {
        text:
          this.type === "transferProductStock"
            ? this.$t("fromProduct")
            : this.$t("product"),
        sortable: true,
        value: "product",
        width: 180,
      },
      {
        text: this.$t("toProduct"),
        sortable: true,
        value: "to_product",
        width: 150,
      },
      {
        text: this.$t("stock"),
        sortable: false,
        value: "stock",
        width: 50,
      },
      {
        text: this.$t("unit"),
        sortable: false,
        value: "unit",
        width: 80,
      },
      {
        text: this.$t("counting_one"),
        sortable: true,
        value: "counting_one",
        width: 75,
      },
      {
        text: this.$t("counting_two"),
        sortable: true,
        value: "counting_two",
        width: 75,
      },
      {
        text:
          this.$route.name !== "warehouseHandlingEdit"
            ? this.$t("count")
            : this.$t("counting_final"),
        sortable: true,
        value: "count",
        width: 90,
      },
      {
        text: this.$t("price"),
        sortable: true,
        value: "price",
        width: 120,
      },
      {
        text: this.$t("expireDate"),
        sortable: true,
        value: "expire_date",
        width: 120,
      },
      {
        text: this.$t("content"),
        sortable: false,
        value: "content",
        width: 150,
      },
      {
        text: this.$t("entrepot"),
        sortable: false,
        value: "entrepot",
        width: 150,
      },
    ];
    this.productStatusItems = [
      {
        value: "active",
        text: this.$t("active"),
      },
      {
        value: "deactive",
        text: this.$t("deactive"),
      },
    ];
    this.selectedHeaders = this.headers;
    this.loadEntrepotTableColumnSettings();
    if (this.input) {
      this.model = this.input;
    }
    this.loading = false;
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.serialCancelToken) {
      this.serialCancelToken.cancel("Canceled due to destroy");
    }
  },
  methods: {
    onResize() {
      var height = 259;
      if (window.innerHeight < 650) {
        height = 299;
      }
      this.tableHeightEntrepot = window.innerHeight - height;
    },
    loadEntrepotTableColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.entrepotColumnPersistKey).then(function (
        snapshot
      ) {
        if (!snapshot || !snapshot.length) return;
        applyColumnSettings(app.headers, snapshot, {
          locked: ["actions", "row", "product"],
          anchor: "product",
        });
        app.$forceUpdate();
      });
    },
    //force update  selected unit
    changeUnit(item) {
      if (!item.product || !item.unit) return;
      const selectedItem = item.product.units?.find((f) => f.unit_id === item.unit.id);
      if (selectedItem) this.$set(item.unit, "value", selectedItem.value);
      if (item.unit.id === item.product.unit.id) {
        item.countUnit = null;
      } else if (item.countUnit) {
        this.convertUnit(item);
      }
      this.$forceUpdate();
    },
    //
    changeEntrepotAtRow(item, index) {},
    convertUnit(item) {
      item.count = item.countUnit * item.unit.value;
    },
    unitItems(item) {
      if (item.product) {
        var units = [item.product.unit];
        if (item.product.units) {
          item.product.units.map(function (value, index) {
            value.unit.value = value.value;
            units.push(value.unit);
          });
        }
        if (!item.unit) {
          item.unit = item.product.unit;
        }
        // if (!item.unit && this.id) {
        //   if (item.unit2) {
        //     item.unit = item.unit2
        //     item.unit.value = item.unitRate
        //   } else {
        //     item.unit = item.product.unit
        //   }
        // }
        return units;
      } else {
        return [];
      }
    },
    openCostListDialog(item) {
      this.costItems = item;
      this.costListDialog = true;
    },
    openCostDialog(item) {
      this.selectedItem = item;
      this.costDialog = true;
    },
    openSerialDialog(item) {
      this.hydrateItemSerials(item);
      if (!item.serials) item.serials = [];
      this.serialItem = item;
      this.serialDialog = true;
      if (this.serialFlow === "out") {
        this.serialPage = 1;
        this.serialLastPage = 1;
        this.serialSearch = "";
        this.$set(item, "serialOptions", []);
        this.fetchProductSerials(item, { page: 1, search: "", append: false });
      }
    },
    getProductHasSerial(product) {
      if (!product) return false;
      const flag = (product.meta && product.meta.has_serial) || product.has_serial;
      return flag === "active";
    },
    rowHasSerial(item) {
      return !!(
        item &&
        (item.has_serial === "active" || this.getProductHasSerial(item.product))
      );
    },
    syncRowSerialFlag(item) {
      if (!item) return;
      const productId = item.product && item.product.id;
      if (this.getProductHasSerial(item.product)) {
        this.$set(item, "has_serial", "active");
        item._serialProductId = productId;
        return;
      }
      if (productId && productId === item._serialProductId) return;
      this.$set(item, "has_serial", "deactive");
      item.serials = [];
      item._serialProductId = productId || null;
    },
    normalizeArticleSerials(source) {
      return (source || [])
        .map((serial, index) => {
          const raw =
            typeof serial === "string"
              ? serial
              : serial &&
                (serial.value ||
                  serial.serial ||
                  serial.serial_number ||
                  serial.code ||
                  "");
          const value = String(raw || "").trim();
          if (!value) return null;
          return {
            id: (serial && (serial.id || serial.serial_id)) || null,
            uid: (serial && (serial.uid || serial.id)) || `${value}-${index}`,
            value,
            created_at: (serial && (serial.created_at || serial.createdAt)) || "",
            selected: serial && serial.selected !== undefined ? !!serial.selected : true,
          };
        })
        .filter(Boolean);
    },
    hydrateItemSerials(item) {
      if (!item || !item.product) return;
      if (this.getProductHasSerial(item.product)) {
        this.$set(item, "has_serial", "active");
        item._serialProductId = item.product.id;
      }
      if (item.serials && item.serials.length) return;
      this.$set(item, "serials", this.normalizeArticleSerials(item.product.serials));
    },
    fetchProductSerials(item, options = {}) {
      if (!item || !item.product || !item.product.id) {
        this.serialsLoading = false;
        return;
      }
      const page = options.page || 1;
      const search = options.search !== undefined ? options.search : this.serialSearch;
      const append = !!options.append;
      if (append && this.serialsLoading) return;
      const entrepotId = (item.article_entrepot || this.entrepot || {}).id;
      var app = this;
      if (app.serialCancelToken) {
        app.serialCancelToken.cancel("Canceled due to new serial request");
      }
      app.serialCancelToken = app.$axios.CancelToken.source();
      const requestId = ++app.serialRequestId;
      app.serialsLoading = true;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            select: "getProductSerials",
            product_id: item.product.id,
            entrepot_id: entrepotId,
            search: search || "",
            page,
          },
          cancelToken: app.serialCancelToken.token,
        })
        .then((res) => {
          if (requestId !== app.serialRequestId || app.serialItem !== item) return;
          const payload = res.data;
          const list = Array.isArray(payload)
            ? payload
            : (payload && payload.data) || [];
          app.serialPage =
            (payload &&
              (payload.current_page ||
                (payload.meta && payload.meta.current_page))) ||
            page;
          app.serialLastPage =
            (payload &&
              (payload.last_page || (payload.meta && payload.meta.last_page))) ||
            1;
          const selectedIds = new Set(
            (item.serials || []).map((serial) => serial.id).filter((id) => id != null)
          );
          const selectedValues = new Set(
            (item.serials || []).map((serial) => String(serial.value || "").trim())
          );
          const optionsList = app.normalizeArticleSerials(list).map((serial) => ({
            ...serial,
            selected:
              selectedIds.has(serial.id) ||
              selectedValues.has(String(serial.value || "").trim()),
          }));
          const merged = append
            ? app.mergeSerialOptions(item.serialOptions, optionsList)
            : app.mergeSerialOptions(app.selectedSerialRows(item), optionsList);
          app.$set(item, "serialOptions", merged);
        })
        .catch((err) => {
          if (!app.$axios.isCancel(err)) {
            app.serverErrorHandeler(err);
          }
        })
        .finally(() => {
          if (requestId === app.serialRequestId) {
            app.serialsLoading = false;
          }
        });
    },
    onSerialSearch(search) {
      if (!this.serialItem || this.serialFlow !== "out") return;
      this.serialSearch = search || "";
      this.serialPage = 1;
      this.fetchProductSerials(this.serialItem, {
        page: 1,
        search: this.serialSearch,
        append: false,
      });
    },
    loadMoreSerials() {
      if (
        !this.serialItem ||
        this.serialFlow !== "out" ||
        this.serialsLoading ||
        this.serialPage >= this.serialLastPage
      ) {
        return;
      }
      this.fetchProductSerials(this.serialItem, {
        page: this.serialPage + 1,
        search: this.serialSearch,
        append: true,
      });
    },
    mergeSerialOptions(existing, incoming) {
      const next = Array.isArray(existing) ? existing.slice() : [];
      const seen = new Set(next.map((serial) => serial.id).filter((id) => id != null));
      incoming.forEach((serial) => {
        if (serial.id != null && seen.has(serial.id)) return;
        if (serial.id != null) seen.add(serial.id);
        next.push(serial);
      });
      return next;
    },
    selectedSerialRows(item) {
      return this.normalizeArticleSerials(item && item.serials).map((serial) => ({
        ...serial,
        selected: true,
      }));
    },
    setSerials(serials) {
      if (!this.serialItem) return;
      this.$set(this.serialItem, "serials", serials);
      if (this.serialFlow === "out" && this.serialItem.serialOptions) {
        const selectedIds = new Set(
          (serials || []).map((serial) => serial.id).filter((id) => id != null)
        );
        this.serialItem.serialOptions.forEach((option) => {
          option.selected = selectedIds.has(option.id);
        });
      }
    },
    sanitizeSerialItems(items) {
      const isOut = this.serialFlow === "out";
      return (items || []).map((item) => {
        const next = { ...item };
        delete next._serialProductId;
        delete next.serialOptions;
        if (isOut) {
          next.serial_ids = (item.serials || [])
            .map((serial) => serial && serial.id)
            .filter((id) => id != null);
          delete next.serials;
        }
        return next;
      });
    },
    buildEntrepotSubmitPayload() {
      const payload = { ...this.$data };
      delete payload.serials;
      delete payload.serial_ids;
      delete payload.serialCancelToken;
      delete payload.serialDialog;
      delete payload.serialItem;
      delete payload.serialsLoading;
      delete payload.serialPage;
      delete payload.serialLastPage;
      delete payload.serialSearch;
      delete payload.serialRequestId;
      payload.items = this.sanitizeSerialItems(this.items);
      return payload;
    },
    setCost(val) {
      var index = this.items.indexOf(this.selectedItem);
      this.items[index].cost.push(val);
      this.costDialog = false;
      this.selectedItem = null;
    },
    addRow() {
      if (this.items.length >= 100) {
        this.snakbarText = this.$t("youCantmoreThan100Record");
        this.snakbarColor = "blue";
        this.snakbar = true;
        return false;
      }
      this.items.push({
        product: null,
        cost: [],
        serials: [],
        stock: null,
        inEdit: 0,
        outEdit: 0,
        countUnit: null,
        counting_one: null,
        counting_two: null,
        expire_date: null,
        to_product: null,
        count: null,
        price: null,
        unit: null,
        content: null,
        article_entrepot: null,
      });
    },
    remove(item, index1) {
      var index = this.items.indexOf(this.deleteItem);
      var cost = this.deleteItem.cost;
      this.items.splice(index, 1);
      this.deletDialog = false;
      if (cost.length > 0) {
        this.removeCost(cost);
      }
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      this.$router.push({ name: "ProductEdit", params: { id: item.id } });
    },
    checkProduct(item, key) {
      this.syncRowSerialFlag(item);
      if (item.product) {
        var index = this.items.findIndex((x) => x.product.id === item.product.id);
        if (!this.id) {
          item.price = item.product.costs;
        }
        if (index !== key) {
          // this.$refs['refProduct' + key].clear()
          this.snakbarText = this.$t("alert-product-is-repetitive");
          this.snakbarColor = "pink";
          this.snakbar = true;
        }
      } else {
        this.removeCost(this.items[key].cost);
        this.items[key].cost = [];
      }
    },
    checkCount(item) {
      if (this.type !== "warehouseHandling") {
        if (
          this.$store.state.negative_inventory === "no" &&
          this.type === "remittance" &&
          parseFloat(item.count) > parseFloat(item.product.stock.count)
        ) {
          this.snakbarText = this.$t("alert-inventory-is-not-enough");
          this.snakbarColor = "pink";
          this.snakbar = true;
          item.count = 0;
        }
      }
    },
    removegroup() {
      var app = this;
      app.selected.map(function (value, key) {
        app.remove(value, key);
      });
    },
    create() {
      // Desktop: form lives on bridged DesktopView ($refs.form).
      // Mobile: EntrepotMobile validates its own form first, then calls create().
      if (this.$refs.form && !this.$refs.form.validate()) return false;
      var app = this;
      app.isLoading = true;
      app.search = null;
          app.$axios
        .post(this.$endpoint + "entrepot", this.buildEntrepotSubmitPayload())
        .then((res) => {
          res = res.data;
          app.snakbarText = app.$t("registered");
          app.snakbarColor = "green";
          app.snakbar = true;
          if (app.$refs.refFilePicker !== undefined && app.attachments) {
            app.$refs.refFilePicker.create(res.data.id);
          }
          this.clearForm();
          app.$emit("close", app.$route);
          this.goTo(app.type + "List");
        })
        .catch((err) => {
          if (err.response && err.response.status === 409) {
            this.$store.commit("SET_PLAN_DIALOG", true);
          }
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    update() {
      var app = this;
      app.isLoading = true;
      app.search = null;
      app.$axios
        .put(this.$endpoint + "entrepot/" + this.$route.params.id, this.buildEntrepotSubmitPayload())
        .then((res) => {
          res = res.data;
          app.$emit("close", app.$route);
          if (app.$refs.refFilePicker !== undefined) {
            app.$refs.refFilePicker.create(res.data.id);
          }
          app.goTo(app.type + "List");
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.isLoading = false));
    },
    show() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "entrepot/" + this.$route.params.id + "/edit", {
          params: {
            id: this.$route.params.id,
          },
        })
        .then((res) => {
          app.$nextTick(() => {
            res = res.data;
            app.type = res.type;
            app.id = res.id;
            app.attachments = res.attachments;
            app.entrepot = res.entrepot;
            app.recipientEntrepot = res.recipient_entrepot;
            app.recipientBranch = res.recipientBranch;
            app.detail = res.detail;
            app.branch = res.branch;
            app.relations = res.invoice;
            app.items = res.articles.map((item) => ({
              ...item,
              count:
                item.count !== null && item.count !== undefined && item.count !== ""
                  ? parseFloat(item.count).toString()
                  : item.count,
            }));
            (app.items || []).forEach((item) => app.hydrateItemSerials(item));
            // app.items = res.articles;
            app.date = res.date;
            app.content = res.content;
            app.status = res.last_status ? res.last_status.status : null;
            if (res.tags) {
              app.tag = res.tags;
            }
            app.render = true;
            app.creatExcelData(res.articles);
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    clearForm() {
      this.selected = [];
      this.printDialog = false;
      this.attachments = null;
      this.deletDialog = false;
      this.showSelect = false;
      this.filter = false;
      this.valid = true;
      this.costItems = null;
      this.detail = null;
      this.recipientEntrepot = null;
      this.relations = null;
      this.productStatus = null;
      this.productStatusItems = null;
      this.entrepot = null;
      this.model = null;
      this.from = 1;
      this.taskDialog = null;
      this.id = null;
      this.status = null;
      this.tag = null;
      this.temp = null;
      this.deleteItem = null;
      this.sellStatus = null;
      this.items = [];
      this.sortBy = [];
      this.dialog = null;
      this.timer = 0;
      this.totalItems = 1000;
      this.isLoading = false;
      this.snakbar = false;
      this.taskId = null;
      this.snakbarText = null;
    },
    remoceCostList(cost) {
      var index = this.costItems.cost.indexOf(cost);
      this.costItems.cost.splice(index, 1);
      this.costListDialog = false;
      this.removeCost([cost]);
    },
    removeCost(cost) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "CostIncome", {
          params: {
            deleteItems: cost,
          },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
        })
        .finally(() => (app.loading = false));
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          id: d.id,
          productName: d.product.name,
          stock:
            d.product && d.product.stock
              ? app.$numberFormat(d.product.stock.count, 3)
              : 0,
          counting_one: d.counting_one ? d.counting_one : "",
          counting_two: d.counting_two ? d.counting_two : "",
          counting_final: d.count ? d.count : "",
          Stock_shortage_or_excess_in_warehouse: app.resolveWarehouseStock(d),
          price: d.price ? app.$numberFormat(d.price) : "",
          expireDate: d.expire_date ? d.expire_date : "",
          content: d.content ? d.content : "",
          entrepot: d.entrepot ? d.entrepot.name : "",
        });
      });
    },
    resolveWarehouseStock(item) {
      if (item.product.stock.count) {
        if (item.count != null) {
          return Number(item.product.stock.count) - Number(item.count);
        } else if (item.counting_two != null) {
          return Number(item.product.stock.count) - Number(item.counting_two);
        } else if (item.counting_one != null) {
          return Number(item.product.stock.count) - Number(item.counting_one);
        }
      } else {
        return Number(item.product.stock.count);
      }
    },
  },
};
</script>
